<div *ngIf="loading"
     class="loading-overlay">
    <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
    <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>


<div class="row animated fadeIn fast">
    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">



            <div class="card-body">

                <!-- cabecera -->
                <div class="row mb-2">

                    <div class="col-3">
                        <div class="input-group border border-dark rounded">
                            <input class="form-control"
                                   type="text"
                                   id="buscaTodo"
                                   autofocus
                                   placeholder="Buscar cualquier dato..."
                                   [(ngModel)]="strBuscarTodo"
                                   (keyup)="buscarTodo($event)" />
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary"
                                        type="button"
                                        title="Limpiar búsqueda"
                                        (click)="limpiaBusca()">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-2">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"><i class="fa-solid fa-user"></i></div>
                            <select class="form-control"
                                    [disabled]="parametrosUrl.id_cliente"
                                    [(ngModel)]="cliSeleccionado"
                                    (ngModelChange)="onClienteSelect($event)">
                                <option value=''>Todos los clientes</option>
                                <option *ngFor="let cli of clientesList"
                                        [value]=cli.id>
                                    {{cli.nombre}}
                                </option>
                            </select>
                        </div>
                    </div>


                    <!-- tipoSeleccionado -->
                    <div class="col-2">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"
                                 title="tipo de aviso"
                                 style="cursor: default">T</div>
                            <select class="form-control"
                                    [(ngModel)]="tipoSeleccionado"
                                    (ngModelChange)="onTipoSelect($event)">
                                <option [ngValue]="null">Todos los tipos</option>
                                <option *ngFor="let tipo of tiposDeAviso"
                                        [ngValue]="tipo.valor">
                                    {{ tipo.titulo }}
                                </option>
                            </select>
                        </div>
                    </div>


                    <!-- leidoSeleccionado -->
                    <div class="col-2">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"
                                 title="Leido"
                                 style="cursor: default">L</div>
                            <select class="form-control"
                                    [(ngModel)]="leidoSeleccionado"
                                    (ngModelChange)="onLeidoSelect($event)">
                                <option [ngValue]="null">Todos los estados</option>
                                <option [ngValue]="0">Sin leer</option>
                                <option [ngValue]="1">Abiertos</option>
                            </select>
                        </div>
                    </div>


                    <div class="col-3">
                        <form>

                            <div class="row float-right">
                                <div class="col-sm-6">
                                    <div class="form-group rounded">
                                        <select class="form-control"
                                                name="rowsLimitStr"
                                                [(ngModel)]="rowsLimitStr"
                                                (change)="rowsLimitChange()">
                                            <option [value]="10">10</option>
                                            <option [value]="50">50</option>
                                            <option [value]="100">100</option>
                                            <option [value]="999999">Todo</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group float-right">
                                        <div class="btn-group">

                                            <button type="button"
                                                    (click)="getListaAvisos()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Recargar datos">
                                                <i class="fa-solid fa-sync"></i>
                                            </button>
                                            <button type="button"
                                                    (click)="exportToExcel()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Descargar Excel">
                                                <i class="fa-solid fa-download"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </form>
                    </div>

                </div>



                <div class="rounded border">

                    <!-- datatable -->
                    <ngx-datatable class="bootstrap"
                                   [style.width]="'100%'"
                                   [columnMode]="'flex'"
                                   [loadingIndicator]="loading"
                                   [headerHeight]="70"
                                   [footerHeight]="50"
                                   [rowHeight]="50"
                                   [limit]="rowsLimit"
                                   [rows]="rows"
                                   [messages]="messages">

                        <!-- id -->
                        <ngx-datatable-column name="id"
                                              [flexGrow]="0.5"
                                              [minWidth]="60"
                                              [maxWidth]="80"
                                              [resizeable]="false">
                            <ng-template ngx-datatable-cell-template
                                         let-value="value">
                                {{value}}
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- fecha -->
                        <ngx-datatable-column name="Fecha"
                                              prop="created_at"
                                              [flexGrow]="1"
                                              [minWidth]="140"
                                              [maxWidth]="140">
                            <ng-template ngx-datatable-cell-template
                                         let-value="value">
                                {{ value | date:'dd/MM/yyyy HH:mm' }}
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- tipo -->
                        <ngx-datatable-column name="Tipo"
                                              prop="tipo"
                                              [flexGrow]="0.5"
                                              [minWidth]="70"
                                              [maxWidth]="90"
                                              [resizeable]="false">
                            <ng-template ngx-datatable-cell-template
                                         let-value="value"
                                         let-row="row">
                                <div class="text-center">

                                    <i *ngIf="value == 1"
                                       class="fa-solid fa-message text-info"
                                       title="Genérico"></i>

                                    <span *ngIf="value == 2">
                                        <a (click)="abrirPedido(row)"
                                           class="pointer">
                                            <i class="fa-solid fa-receipt text-primary"
                                               title="Abrir pedido"></i>
                                        </a>
                                    </span>

                                    <i *ngIf="value == 3"
                                       class="fa-solid fa-truck text-secondary"
                                       title="Entradas"></i>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- cliente -->
                        <ngx-datatable-column name="Cliente"
                                              prop="cliente.nombre"
                                              [flexGrow]="1"
                                              [minWidth]="100">
                            <ng-template ngx-datatable-cell-template
                                         let-value="value">
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- mensaje -->
                        <ngx-datatable-column name="Notificación"
                                              prop="mensaje"
                                              [flexGrow]="5"
                                              [minWidth]="400"
                                              [wordWrap]="true">
                            <ng-template ngx-datatable-cell-template
                                         let-value="value">
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"
                                     class="mensaje-cell"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- leido -->
                        <ngx-datatable-column name="Estado"
                                              prop="leido"
                                              [flexGrow]="0.5"
                                              [minWidth]="70"
                                              [maxWidth]="90"
                                              [resizeable]="false">
                            <ng-template ngx-datatable-cell-template
                                         let-value="value">
                                <div class="text-center">
                                    <i *ngIf="value == 0"
                                       class="fa-solid fa-envelope text-verde"
                                       title="Sin leer"></i>
                                    <i *ngIf="value == 1"
                                       class="fa-solid fa-envelope-open text-secondary"
                                       title="Leido"></i>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- acciones -->
                        <ngx-datatable-column [flexGrow]="0.5"
                                              [minWidth]="70"
                                              [maxWidth]="100"
                                              [sortable]="false">
                            <ng-template let-row="row"
                                         let-value="value"
                                         ngx-datatable-cell-template>

                                <div ngbDropdown
                                     class="d-inline-block "
                                     container="body">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                            data-toggle="dropdown"
                                            type="button"
                                            style="border-width: 1px;">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-left">
                                        <a (click)="abrirMsg(row)"
                                           class="link mr-2 dropdown-item "
                                           title="Ver mensaje">
                                            <i class="fa-solid fa-eye"></i> Ver mensaje
                                        </a>

                                        <a (click)="(row.tipo === '2' ) ? abrirPedido(row) : null"
                                           class="link mr-2 dropdown-item"
                                           title="Abrir pedido"
                                           [ngClass]="{'disabled': row.tipo !== '2' }">
                                            <i class="fa-solid fa-solid fa-receipt"></i> Abrir pedido
                                        </a>

                                        <hr style="margin: 0px;">

                                        <a (click)="deleteRow(row)"
                                           class="link mr-2 dropdown-item text-danger"
                                           title="Borrar registro">
                                            <i class="fa-regular fa-trash-can fa"></i> Borrar mensaje
                                        </a>

                                    </div>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>

                </div>

            </div>
        </div>
    </div>

</div>